export function findPackingListItemByKey(key) {
    return function (item) {
        return item.userId === key.userId && item.legalId === key.legalId;
    };
}
export function findPackingListItemByMessage(message) {
    return findPackingListItemByKey(message);
}
